<template>
  <el-dropdown-menu v-bind="$attrs" v-on="$listeners">
    <slot></slot>
  </el-dropdown-menu>
</template>
<script>
export default {
  name: "aia-dropdown-menu"
};
</script>